<template src="../templates/normal_fcont_114.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import DesignPaperTiles from '../components/DesignPaperTiles'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '114',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,
    PrintButton,DesignPaperTiles,ReleaseDateForArticle,AppDownloadCreative
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['114-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['114-2']}
    ]};

  }
  
};
</script>
<style >

</style>

